<template>
    <div>
        <section class="bar background-pentagon no-mb a" style="    height: 350px;">
          <div class="container ">
            <h2 class="text-uppercase">创新型企业</h2>
            <br>
            <div class="row showcase text-center   ">
              <div class="col-md-3 col-sm-6 animate__animated animate__fadeInUp">
                <div class="item">
                  <div class="icon-outlined   icon-thin animate__animated animate__fadeInUp"><el-icon size="30px"><Paperclip /></el-icon></div>
                  <h4 ><span class="h1 counter" id="count1">100</span><span class="h1  ">+</span><br> 药品种类</h4>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="item">
                  <div class="icon-outlined   icon-thin animate__animated animate__fadeInUp"><el-icon size="30px"><MessageBox /></el-icon></div>
                  <h4 ><span class="h1 counter">10</span><span class="h1">+</span><br>在研产品项目</h4>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="item">
                  <div class="icon-outlined  icon-thin animate__animated animate__fadeInUp"><el-icon size="30px"><Location /></el-icon></div>
                  <h4><span class="h1 counter">2</span><span class="h1"></span><br>药品生产基地</h4>
                </div>
              </div>
              <div class="col-md-3 col-sm-6">
                <div class="item">
                  <div class="icon-outlined   icon-thin animate__animated animate__fadeInUp"><el-icon size="30px"><Van /></el-icon></div>
                  <h4><span class="h1 counter">30</span><span class="h1">+</span><br>产品销售地区</h4>
                </div>
              </div>
            </div>
          </div>
      </section>
    </div>
</template>
<style scoped>
.icon-outlined {
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    display: inline-block;
    font-size: 1.4rem;
    border-radius: 50%;
    border: 2px solid #fff;
    margin-bottom: 20px;
}
.item {
      color: unset !important; 
    border-left: 2px solid #fff;
    margin-left: 25px;
    font-size: 15px;
}
.el-icon {
 
  margin-top:25px;
}
.showcase .icon-outlined {
    border-color: #555;
}

.icon-outlined.icon-thin {
    border-width: 1px;
}
.icon-outlined.icon-sm {
    width: 55px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    font-size: 1.15rem;
}
 .col-sm-6 {
    margin-top:20px
 }
 .h1 {
    color: red;
    font-size: 72px;;
 }
</style>
<script>
 
</script>
